import { render, staticRenderFns } from "./UsuarioNew.vue?vue&type=template&id=776f3027"
import script from "./UsuarioNew.vue?vue&type=script&lang=js"
export * from "./UsuarioNew.vue?vue&type=script&lang=js"
import style0 from "./UsuarioNew.vue?vue&type=style&index=0&id=776f3027&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports